import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Inline, Box, Text } from '@atlaskit/primitives/compiled';
import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import { token } from '@atlaskit/tokens';
import { cssMap, cx } from '@atlaskit/css';

import { AIFeedbackComponent, AIFeedbackPropertiesProvider } from '@atlassian/ai-components';

const AI_SNIPPETS_POPULAR_FOLLOWING_FEEDS_CONTENT_ID = 'bd3af97d-5e24-463c-a29a-6e23233bbe8a';

const i18n = defineMessages({
	aiDisclaimerText: {
		id: 'feed.ai-disclaimer-text',
		defaultMessage: 'Summaries use AI. Verify results.',
		description:
			'Disclaimer above feed content informing users that summaries are AI-generated and should be verified.',
	},
	statusInformationIconLabel: {
		id: 'feed.status-information-icon-label',
		defaultMessage: 'Summaries use AI. Verify results.',
		description: 'Label for the Status Information Icon',
	},
});

const aiDisclaimerStyles = cssMap({
	disclaimer: {
		textDecoration: 'none',
		marginRight: token('space.075'),
	},
	icon: {
		marginRight: token('space.075'),
	},
	container: {
		paddingTop: token('space.100'),
		paddingBottom: token('space.150'),
		marginBottom: token('space.050'),
	},
});

export const FeedSnippetsFeedbackComponent = (): React.JSX.Element => {
	const intl = useIntl();

	const disclaimerMessage = intl.formatMessage(i18n.aiDisclaimerText);
	const statusInformationIconLabel = intl.formatMessage(i18n.statusInformationIconLabel);
	return (
		<AIFeedbackPropertiesProvider entrypointId={AI_SNIPPETS_POPULAR_FOLLOWING_FEEDS_CONTENT_ID}>
			<Inline space="space.100" xcss={cx(aiDisclaimerStyles.container)}>
				<Inline xcss={cx(aiDisclaimerStyles.disclaimer)} alignBlock="center">
					<Box xcss={cx(aiDisclaimerStyles.icon)}>
						<StatusInformationIcon
							label={statusInformationIconLabel}
							size="small"
							color={token('color.text.subtlest')}
						/>
					</Box>
					<Text size="small" color="color.text.subtlest">
						{disclaimerMessage}
					</Text>
				</Inline>
				<AIFeedbackComponent contentId="ai-snippets-popular-following-feeds" />
			</Inline>
		</AIFeedbackPropertiesProvider>
	);
};
